import { AuthService } from '@uw/core/services/auth.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, FormGroupDirective, NgForm} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { ActivatedRoute } from '@angular/router';
import { MenuService } from '@uw/themes/services/menu.service';
import { LayoutUtilsService, MessageType } from '@uw/shared/services/layout-utils.service';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AlertService } from '@uw/core/services/alert.service';
import { AlertPageType, LoginAlert } from '@uw/core/enums/alert-pagetype.enum';
import { Alert } from '@uw/core/models/alert.model';
import { combineLatest } from 'rxjs';
import { CustomNavigationService } from '@uw/core/custom-navigation.service';
import { ChangePasswordFormComponent } from '../change-password-form/change-password-form.component';
import { LanguageSelectorComponent } from '../../../../shared/components/language-selector/language-selector.component';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    imports: [ChangePasswordFormComponent, LanguageSelectorComponent, TranslateModule]
})
export class ResetPasswordComponent implements OnInit {

  errorMessage!: string;
  resetToken: string = '';
  email: string = '';
  buttonLoading = false;
  cguid: string = '';
  firstTime: boolean = false;
  alerts: Alert[] = [];
  passwordRequirementMessage: string;
  invalidTokenMessage: string;

  readonly currentLanguage = this.translateService.currentLang;

  constructor(private fb: UntypedFormBuilder,
    private authService: AuthService,
    protected customNavigationService: CustomNavigationService,
    private layoutUtilsService: LayoutUtilsService,
    private translateService: TranslateService,
    private activatedRoute: ActivatedRoute,
    private menuService: MenuService,
    private alertService: AlertService,
  ) {
    // super();
    this.menuService.showDonarSubMenu(true);
  }

  ngOnInit(): void {
    combineLatest([this.activatedRoute.queryParams, this.alertService.fetchAlerts(AlertPageType.LOGIN)])
      .subscribe(([queryParams, alerts]) => {
        this.alerts = alerts;
        if (queryParams.resetToken) {
          this.resetToken = encodeURIComponent(queryParams.resetToken);
          this.email = queryParams.email;
          this.cguid = queryParams.cguid;
          this.firstTime = !!queryParams.firstTime;
          if (this.email && this.email.includes('')){

            this.email= this.email.replace(' ','+');
          }
          this.verifyToken();
        } else {
          this.customNavigationService.navigate(['/']);
        }
      });

      this.alertService.fetchAlerts(AlertPageType.LOGIN).subscribe(
        alerts => {
          this.alerts = alerts;
         const pwdAlertMessage = this.alerts.find(al => al.name == LoginAlert.STRONG_PASSWORD_MESSAGE);
         if (pwdAlertMessage) {
          this.passwordRequirementMessage = (this.currentLanguage == 'en') ? pwdAlertMessage.contentXML: pwdAlertMessage.contentXML_fr;
          } else {
            this.passwordRequirementMessage = this.translateService.instant('change_password.pwd_requirements_msg');
          }

        },
        _error => {
          this.alerts = [];
        }
      );
  }

  onNoClick(): void {
    //this.dialogRef.close();
  }

  setPassword(setPasswordFormData: any): void {

    this.errorMessage = '';
    const {newPassword: password, confirmPassword} = setPasswordFormData;
    this.resetPasswordEndpoint({password, confirmPassword}).subscribe(_data => {
      this.showSuccess('change_password.password_updated_msg');
      // this.customNavigationService.navigate(['/donor'], { queryParams: { cguid: this.cguid } });
      this.customNavigationService.navigate(['/main/login']);

    }, err => {
      this.errorMessage =
        err && err.message && err.message == 'cannot_reuse_password'
        ? this.translateService.instant(
            'change_password.error.code.cannot_reuse_password'
          ) :
          this.translateService.instant('messages.password_update_failed');
    });
  }

  showSuccess(message: string) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message),
      MessageType.Success
    );
  }

  showError(message: string) {
    this.layoutUtilsService.showNotification(
      this.translateService.instant(message),
      MessageType.Error
    );
  }


  verifyToken(){
    this.errorMessage = '';
    this.verifyTokenEndpoint().subscribe(_data=> {
        return;
    }, err=>{
      const alertMessage = this.alerts.find(al => al.name == LoginAlert.INVALID_TOKEN_MESSAGE);
         if (alertMessage) {
          this.invalidTokenMessage = (this.currentLanguage == 'en') ? alertMessage.contentXML: alertMessage.contentXML_fr;
          } else {
            this.invalidTokenMessage = this.translateService.instant('common.invalid_token');
          }
      this.errorMessage = this.translateService.instant('messages.password_update_failed');
      
      if (err.message != 'Invalid welcome link') {
        this.showError( this.invalidTokenMessage);
      }
      
      this.customNavigationService.navigate(['main/login']);
    });
  }

  verifyTokenEndpoint(){
    return this.resetToken && this.resetToken.length > 40
        ? this.authService.verifyToken(this.resetToken, this.email, this.firstTime)
        : this.authService.verifyNewToken(this.resetToken, this.email, this.firstTime);
  }

  resetPasswordEndpoint(setPasswordFormData: any){
    return this.resetToken && this.resetToken.length > 40
        ? this.authService.resetPassword(setPasswordFormData, this.resetToken, this.email, this.firstTime)
        : this.authService.resetPasswordPasswordGuid(setPasswordFormData, this.resetToken, this.email, this.firstTime);
  }

  showPassword(passwordControl: HTMLInputElement) {
    if (passwordControl.type === "password") {
      passwordControl.type = "text";
    } else {
      passwordControl.type = "password";
    }
  }

}

